module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "admin-filter"
    }
  }, [_c('h4', [_vm._v("Consolidation Point filter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Origin Port")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.ports,
      "title": "Origin Port",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.originPort,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectOrigin
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Destination Port")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.ports,
      "title": "Destination Port",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.destinationPort,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectDestination
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.emitSearch
    }
  }, [_vm._v("\n      Search\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Cancel\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34774f13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/ConsolidationPoint/ConsolidationPointFilter.vue
// module id = 2146
// module chunks = 1